import { createApp } from 'vue';
import moment from "moment";

// Fetch Blog Posts from WP REST API
let app = createApp({
  el: "",
  delimiters: ["${", "}"],
  data() {
    return {
      loaded: false,
      rawPosts: [],
      posts: [],
      totalPagesLoaded: 1,
      currentPage: 1,
      currentFilter: "all",
  
      perPage: 9,
      totalPages: 0,
  
      display: {
        total: 0,
        shown: 0,
      },
  
      headers: {
        totalEntires: 0,
        totalQueryPages: 0,
      },
    }
  },
  filters: {
    dateFormat: function (pubDate) {
      let date = new Date(pubDate);
      // console.log(pubDate, "\n", date, "\n", moment(date).format("MMMM D, YYYY"));

      return moment(date).format("MMMM D, YYYY");
    },
  },
  mounted: function () {
    const t = this;

    t.fetchAPI();
  },
  methods: {
    decodeHtml: function (html) {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.textContent;
    },
    fetchAPI: function () {
      const t = this;
      fetch(
        "/wp-json/wp/v2/tips-guides/?per_page=100&page=" +
          t.$data.totalPagesLoaded
      )
        .then(function (response) {
          if (response.ok) {
            response.headers.forEach(function (element, index) {
              if (index === "x-wp-total") {
                t.$data.headers.totalEntires = parseInt(element);
              }

              if (index === "x-wp-totalpages") {
                t.$data.headers.totalQueryPages = parseInt(element);
              }
            });

            return response.json();
          } else {
            return Promise.reject(response);
          }
        })
        .then(function (data) {
          t.$data.totalPages = t.$data.headers.totalEntires / t.$data.perPage;
          t.parseBlogData(data);
        })
        .catch(function (err) {
          console.warn("Something went wrong.", err);
        });
    },
    parseBlogData: function (jsonData) {
      const t = this;
      let images = null;

      for (let i = 0, length1 = jsonData.length; i < length1; i++) {
        if (
          typeof jsonData[i].acf.options != "undefined" &&
          jsonData[i].acf.options.corporate_hidden
        ) {
          continue;
        }

        if (!jsonData[i].acf.is_featured) {
          if (jsonData[i].acf.featured_image) {
            images = {
              alt: jsonData[i].acf.featured_image.alt,
              src: jsonData[i].acf.featured_image.sizes["blog-thumb"],
              width: jsonData[i].acf.featured_image.sizes["blog-thumb-width"],
              height: jsonData[i].acf.featured_image.sizes["blog-thumb-height"],
            };
          } else {
            images = null;
          }

          t.$data.rawPosts.push({
            id: jsonData[i].id,
            title: jsonData[i].title,
            slug: jsonData[i].slug,
            link: jsonData[i].link,
            pubDate: {
              raw: jsonData[i].date,
            },
            tagName: jsonData[i].acf.tag.name,
            tag: jsonData[i].acf.tag.slug,
            images: images,
          });
        }
      }

      if (t.$data.totalPagesLoaded < t.$data.headers.totalQueryPages) {
        t.$data.totalPagesLoaded++;
        t.fetchAPI();
      } else {
        t.loaded = true;
        t.displayPosts("all");
      }
    },

    loadMore: function (e) {
      this.$data.currentPage++;
      this.displayPosts(this.$data.currentFilter);
    },

    filter: function ($event, $tag) {
      let tagNodes = $event.target.parentNode.parentNode.childNodes;

      for (let k = 0, length3 = tagNodes.length; k < length3; k++) {
        if (tagNodes[k].nodeType === 1) {
          tagNodes[k].childNodes[0].classList.remove("cur");
        }
      }

      $event.target.classList.add("cur");

      this.$data.currentPage = 1;
      this.$data.currentFilter = $tag;
      this.$data.display.shown = 0;

      this.displayPosts(this.$data.currentFilter);
    },

    displayPosts: function ($filter) {
      const t = this;

      t.$data.posts = [];
      t.$data.display.total = 0;

      // var loopCounter = ((t.$data.perPage * t.$data.currentPage) > t.$data.rawPosts.length) ? t.$data.rawPosts.length : (t.$data.perPage * t.$data.currentPage);

      for (let k = 0, length3 = t.$data.rawPosts.length; k < length3; k++) {
        if ($filter === "all") {
          t.$data.display.total++;
        } else {
          if ($filter === t.$data.rawPosts[k].tag) {
            t.$data.display.total++;
          }
        }
      }

      var loopCounter = t.$data.perPage * t.$data.currentPage;

      for (let i = 0, length1 = t.$data.rawPosts.length; i < length1; i++) {
        console.log("displayPosts:", $filter, t.$data.rawPosts[i]);

        if ($filter === "all" && loopCounter !== 0) {
          t.$data.posts.push(t.$data.rawPosts[i]);
          loopCounter--;
        } else {
          if ($filter === t.$data.rawPosts[i].tag && loopCounter !== 0) {
            t.$data.posts.push(t.$data.rawPosts[i]);
            loopCounter--;
          }
        }
      }

      t.$data.display.shown = t.$data.posts.length;
    },
  },
}).mount('#blog-post-app');
